export default defineNuxtPlugin(() => {
    const userAuth = useCookie('token')
    const config = useRuntimeConfig().public;
    
    const $customFetch = $fetch.create({
      baseURL: config.serviceURL ?? '',
      onRequest({ request, options, error }) {
        if (userAuth.value) {
          // Add Authorization header
          options.headers = options.headers || {}
          options.headers.Authorization = `Bearer ${userAuth.value}`
        }
      },
      onResponse ({ response }) {
        
      },
      onResponseError({ response }) {
        if (response.status === 401) {
          return navigateTo('/login')
        }
      }
    })
    // Expose to useNuxtApp().$customFetch
    return {
      provide: {
        customFetch: $customFetch
      }
    }
  })